//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Service from '@/service/index'
export default {
    props: {
        item: {
            type: Object,
            default: {}
        },
        keyName: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: ''
        }
    },
    methods: {
        goDetail (e) {
            this.$emit('goDetail', this.item, this.type)
        },
        checkShowPrice (item, type) {
            return item && item.price_desc_arr && item.price_desc_arr.length && type !== '即将预售'
        },
        getMatching (char, keyWords) {
            var item = char.toLowerCase();
            var keyName = keyWords.toLowerCase();
            return keyName.indexOf(item) !== -1
        },
        getStatus (status) {
            return status === '即将取证' ? '即将预售' : status
        }
    }
}
